import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useArsipListModel} from "@/stores/models/arsip-list-model";

export const useArsipListStore  = defineStore(
    'arsipListStore',
    () => {
        const isLoading = ref(false);
        const dataSourceArsipList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useArsipListModel().arsipListCustomStore,
                filter: null,
            })
        );

        // const dataSourceKgbList = (additionalParams = null) => {
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return useKgbListModel().kgbListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        // const dataSourceArsipPegawaiList = ref(null);
        // const dataSourceArsipDewasList = ref(null);

        // const dataSourceGajiDireksiHistory = ref(
        //     new DataSource({
        //         requireTotalCount: true,
        //         store: useArsipListModel().arsipListCustomStore,
        //         filter: ['gajis_pegawai_status_id', '=', 1],  // Updated value
        //     })
        // );


        const state = ref(true);
        const refresh =()=>{
            state.value = false;
            dataSourceArsipList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceArsipList.value.reload();
        };

        return {
            dataSourceArsipList,
            isLoading,
            refresh,
            initialized,
            state

        }
    }
);